// CourseAvatar — the leading avatar for a course/module (#40). A book (course)
// icon with the owning organisation's logo as a corner badge — the candidate
// scans by "it's a course" first, org second. One place so every course surface
// (cards, rows, detail header) stays consistent.
//
// `plain` drops the org badge → a bare book chip. Employer surfaces pass it: an
// employer only ever sees their own org, so the logo is redundant weight there.
// (Candidate-preview surfaces leave it off, so they show the logo like a
// candidate would.)
import React from 'react';
import { BookOpen } from 'lucide-react';
import { EntityAvatar } from '@/components/custom-ui/EntityAvatar';

interface CourseAvatarProps {
    organisationName?: string;
    organisationLogoUrl?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    /** Employer view — omit the org logo badge, render a plain book chip. */
    plain?: boolean;
}

export const CourseAvatar: React.FC<CourseAvatarProps> = ({ organisationName, organisationLogoUrl, size = 'md', plain }) => (
    <EntityAvatar
        icon={BookOpen}
        tone="brand"
        size={size}
        orgName={plain ? undefined : organisationName}
        orgLogoUrl={plain ? undefined : organisationLogoUrl}
    />
);

export default CourseAvatar;
